<template>
    <div class="center-box powerStation-center ps-right">
        <div
            v-for="(item, i) in target1"
            :key="'target1' + i"
            class="flex align-center target4 station-info">
            <img class="img" :src="item.icon" />
            <div class="flex flex-direction flex1">
                <div class="label">{{ item.label}}</div>
                <div class="num text flex align-center" :style="{'color': item.color}">{{ item.number }}</div>
            </div>
        </div>
    </div>
</template>

<script>
// import title1 from '@/views/exposition/components/title1'
export default {
    // components: {
    //     title1
    // },
    props: {
        target: {
            type: Array,
            default: () => { return [] }
        }
    },
    watch: {
        target(val) {
            this.target1 = val
        }
    },
    data() {
        return {
            target1: this.target 
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>